// extracted by mini-css-extract-plugin
module.exports = {"podcastContainer":"PodcastList_podcastContainer__2wh9w","title":"PodcastList_title__26K-N"};